import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, switchMap } from 'rxjs';
import { UserLogin } from '../models/user-login.interface';
import { UserDTO } from '../models/users.dto';
import { BackofficeCompanyFacade } from './backoffice-company.facade';
import { AuthFacade } from './auth.facade';
import { BackofficeCompanyDetailDTO } from '../models/company-backoffice-detail.interface';

@Injectable({ providedIn: 'root' })
export class AuthorizationFacade {

  constructor(
    private authFacade: AuthFacade,
    private companyFacade: BackofficeCompanyFacade) { }

  changeCompany(companyId: string): Observable<BackofficeCompanyDetailDTO | undefined> {
    return this.authFacade.changeCompany(companyId);
  }


  loadDefaultContext(): Observable<any> {

    return this.authFacade.loadUserIntoIdentity()
      .pipe(
        switchMap((user) => {
          if (user && user.id !== '00000000-0000-0000-0000-000000000000' && !user.assignedRoles.find(x => x.name === 'Student')) {
            // ⚠ Detail firmy je doplněk, ne podmínka startu. Endpoint je pod politikou
            // BackofficeSection, která pouští jen roli Admin — SuperAdmin bez claimu
            // k aktuální firmě tedy dostane 403. Neodchycený spadl v APP_INITIALIZER
            // a aplikace se nevykreslila vůbec: bílá stránka bez hlášky (EL-2089 #5).
            return this.companyFacade.loadCompanyInfoIntoIdentity(user.currentCompanyId).pipe(
              catchError(() => of(user)),
            );
          }

          return of(user);
        })
      );
  }

  loginIntoIdentity(data: UserLogin): Observable<UserDTO | undefined> {
    return this.authFacade.loginUser(data)
      .pipe(
        switchMap((user) => {
          if (!user!.assignedRoles.find(x => x.name === 'Student')) {
            // ⚠ Totéž při přihlášení: 403 z detailu firmy propadl ven jako chyba loginu,
            // takže uživatel dostal „špatné jméno nebo heslo" u správně zadaného hesla.
            // Přihlášení už proběhlo — tohle ho nesmí shodit (EL-2089 #5).
            return this.companyFacade.loadCompanyInfoIntoIdentity(user?.currentCompanyId!).pipe(
              catchError(() => of(undefined)),
              map(() => user),
            );
          }
          return of(user);
        }),
      );
  }

  logoutUser(): Observable<undefined> {
    return this.authFacade.logoutUser();
  }

  logoutEverywhereUser(): Observable<undefined> {
    return this.authFacade.logoutEverywhereUser();
  }

  otherActiveSessions(): Observable<number> {
    return this.authFacade.otherActiveSessions();
  }
}
